import AddIcon from '@mui/icons-material/Add'
import { Box, Button, ToggleButton, ToggleButtonGroup } from '@mui/material'
import React, { useContext, useState } from 'react'

import { Page } from '../../components'
import { CannedJobPartsDialogUI } from '../../components/CannedJobs/PartsDialogUI/CannedJobPartsDialogUI'
import { useAddCustomPartsDialog } from '../../components/CannedJobs/useAddCustomPartsDialog/useAddCustomPartsDialog'
import { AddInvoiceDialog } from '../../components/Inventory/AddInvoiceDialog'
import { useEditInventory } from '../../components/Inventory/useEditInventory/useEditInventory'
import { OutlinedBox } from '../../components/SharedUI'
import { AppContext } from '../../providers/AppProvider/AppProvider'
import {
  InventoryContext,
  InventoryType,
  InventoryTypeName
} from '../../providers/InventoryProvider/InventoryProvider'
import { customToggleButton } from '../../styles/customToggleButton'
import { NONE_ID } from '../../utils/convertEmptyStringToUndefined/convertEmptyStringToUndefined'
import { InventoryProductTable } from './InventoryProductTable'
import { InventoryTable } from './InventoryTable'

export default function Inventory() {
  const { view, setView } = useContext(InventoryContext)
  const { gridBoxHeight } = useContext(AppContext)
  const { setCustomProps: setEditInventoryProps, EditInventoryDialog } =
    useEditInventory()
  const { setCustomProps: setAddCustomPartsProps, customPartsDialogProps } =
    useAddCustomPartsDialog({
      submitCallback: undefined,
      cannedJobId: undefined,
      counterSaleId: undefined
    })

  const [isOpenInvoice, setIsOpenInvoice] = useState<boolean>(false)

  return (
    <Page title="Inventory">
      <EditInventoryDialog />
      {customPartsDialogProps && (
        <CannedJobPartsDialogUI
          {...customPartsDialogProps}
          defaultPartsMatrixId={NONE_ID}
        />
      )}
      {isOpenInvoice && (
        <AddInvoiceDialog handleCancel={() => setIsOpenInvoice(false)} />
      )}
      <OutlinedBox
        title="Inventory"
        noPadding={true}
        actionsMid={
          <ToggleButtonGroup
            value={view}
            exclusive
            onChange={(
              event: React.SyntheticEvent,
              newView: InventoryType | null
            ) => {
              if (newView !== null) {
                setView(newView)
              }
            }}
            size="small"
            data-testid="viewToggleButton"
            sx={customToggleButton}>
            {Object.keys(InventoryTypeName).map((type) => (
              <ToggleButton value={type} key={type}>
                {InventoryTypeName[type as InventoryType]}
              </ToggleButton>
            ))}
          </ToggleButtonGroup>
        }
        actionsRight={
          <>
            {view !== 'product' ? (
              <>
                <Button
                  variant="outlined"
                  startIcon={<AddIcon />}
                  onClick={() => {
                    setIsOpenInvoice(true)
                  }}
                  sx={{ mr: 1 }}>
                  Invoice
                </Button>
                <Button
                  variant="outlined"
                  startIcon={<AddIcon />}
                  onClick={() => {
                    setEditInventoryProps({ existingEntry: undefined })
                  }}>
                  Part
                </Button>
              </>
            ) : (
              <Button
                variant="outlined"
                startIcon={<AddIcon />}
                onClick={() => {
                  setAddCustomPartsProps({
                    existingEntry: undefined
                  })
                }}>
                Product
              </Button>
            )}
          </>
        }>
        <Box sx={{ height: gridBoxHeight }}>
          {view !== 'product' ? <InventoryTable /> : <InventoryProductTable />}
        </Box>
      </OutlinedBox>
    </Page>
  )
}
